import { z } from "zod";
import { validateEmail, validatePhoneNumber, validateUrl } from "vue-app/utils/validators";

const translation = window._trans._register.form.validation;

// Regex for Polish and Portuguese diacritics
const diacriticsRegex = /[ąćęłńóśźżĄĆĘŁŃÓŚŹŻãáàâçéêíôõúüÃÁÀÂÇÉÊÍÔÕÚÜ]/;

export const RegisterFormSchema = z.object({
  name: z
    .string()
    .min(1, translation.required)
    .transform((val) => val.trim())
    .pipe(
      z
        .string()
        .min(2, translation.name.minChars)
        .max(50, translation.name.maxChars)
        .regex(/^[\p{L}\s]+$/u, translation.name.notValid)
    ),
  email: z
    .string()
    .min(1, translation.required)
    .transform((val) => val.trim())
    .pipe(
      z
        .string()
        .min(6, translation.email.minChars)
        .refine((val) => {
          const userPart = val.split("@")[0];
          return !userPart || userPart.length <= 64;
        }, translation.email.maxChars)
        .refine((val) => !diacriticsRegex.test(val), translation.email.onlyLatin)
        .refine((val) => validateEmail(val), translation.invalid.email)
        .refine((val) => !val.includes(" ") && !val.includes(","), translation.email.noSpacesCommas)
    ),
  phoneNumber: z
    .string()
    .min(1, translation.required)
    .transform((val) => val.trim())
    .pipe(
      z
        .string()
        .min(9, translation.phone.minChars)
        .max(20, translation.phone.maxChars)
        .refine((val) => validatePhoneNumber(val), translation.invalid.phone)
    ),
  shopUrl: z
    .string()
    .min(1, translation.required)
    .transform((val) => val.trim())
    .pipe(
      z
        .string()
        .min(3, translation.shopUrl.minChars)
        .max(50, translation.shopUrl.maxChars)
        .refine((val) => !diacriticsRegex.test(val), translation.shopUrl.onlyLatin)
        .refine((val) => validateUrl({ url: val }), translation.invalid.url)
    ),
});

export type RegisterFormModel = z.infer<typeof RegisterFormSchema>;

export const RegisterFormDefaultValues: RegisterFormModel = {
  name: "",
  email: "",
  phoneNumber: "",
  shopUrl: "",
};
